import { useCallback, useState } from 'react'
import { OrgId } from 'app/common/types/id'
import { useComplexesCopySort } from 'app/dataProviders/complexes/copySort/hooks'

type State = {
  pending: boolean
}

type Handlers = {
  submit: () => void
  onSelectedOrgs: (orgsIds: Array<string>) => void
}

interface Options {
  orgId: OrgId
  onSuccess: () => void
}

export function useCopySortKitsSubmit({ orgId, onSuccess }: Options): [State, Handlers] {
  const [selectedOrgs, setSelectedOrgs] = useState<Array<OrgId>>([])
  const { submit, pending } = useComplexesCopySort()

  const handleSubmit = useCallback(async () => {
    const res = await submit({ orgId, toOrgIds: selectedOrgs })
    if (res) {
      onSuccess()
    }
    return res
  }, [submit, orgId, selectedOrgs, onSuccess])

  const handleSelectedOrgs = useCallback(async (toOrgIds: Array<string>) => {
    setSelectedOrgs(toOrgIds as Array<OrgId>)
  }, [])

  return [
    {
      pending,
    },
    {
      submit: handleSubmit,
      onSelectedOrgs: handleSelectedOrgs,
    },
  ]
}
